import { PasswordInput, PasswordInputProps } from "@mantine/core"
import { useTranslation } from "react-i18next"

export function DefaultPasswordInput(props: PasswordInputProps) {
  const { t } = useTranslation("app_server")
  return (
    <PasswordInput
      label={t("Password")}
      placeholder={t("Password")}
      withAsterisk
      maxLength={128}
      required
      {...props}
    />
  )
}
